var setPrototypeOf = require("./setPrototypeOf");

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose;


//////////////////
// WEBPACK FOOTER
// ./~/uncontrollable/~/@babel/runtime/helpers/inheritsLoose.js
// module id = 252
// module chunks = 0